<ng-container *ngIf="result">
  <div class="col-12 px-2 d-md-none">
    <div class="row pb-3">
      <div class="col-12 no-gutters p-0 position-static mt-1"
           data-cy="cms-faq-result-item"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col-12 my-auto px-2 text-center pl-3">
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
      </div>
    </div>
  </div>

  <div class="col-10 pl-3 position-static mt-1 d-md-inline-block d-none as-center"
       data-cy="cms-faq-result-item"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>

  <div class="col-2 ml-auto mt-1 pr-md-1 pr-lg-3 text-right d-md-inline-block d-none">
    <ng-container *ngTemplateOutlet="buttons"></ng-container>
  </div>
</ng-container>

<ng-template #content>
  <div class="faq-result">
    <div class="result-item">
      <strong [innerHTML]="result.title"></strong>
      <span class="content-type"
            *ngIf="result.contentType?.length"
      >
        {{ result.contentType }}
      </span>
    </div>
  </div>
  <div [ngClass]="[!isCollapsed ? 'd-grid' : '']"
       class="col-12 collapse-content-wrapper"
       [@smoothCollapse]="isCollapsed ? 'initial' : 'final'"
  >
    <div class="col-12 my-3 px-0 collapse-content"
         data-cy="cms-faq-collapse-content"
         [innerHTML]="faqSnippet | safeHtml"
    ></div>
  </div>
</ng-template>

<ng-template #buttons>
  <button *ngIf="isCollapsed"
          type="submit"
          data-cy="cms-faq-expand-button"
          class="btn btn-sm mr-1 mb-1 mt-md-2 mt-lg-0 mb-family-line-buttons expand-family-line"
          [ngClass]="[(areFacetsVisible$ | async) ? 'mb-search-family-line-shrink' : '']"
          (click)="toggleCollapsed()"
  >
    <img src="../../../assets/icons/svg/arrow_down_transparent_background.svg"
         title="Expand"
         alt="Expand icon"
         aria-label="Expand icon"
         data-cy="cms-faq-expand-button-icon"
    />
  </button>

  <button *ngIf="!isCollapsed"
          type="submit"
          data-cy="cms-faq-collapse-button"
          [ngClass]="[(areFacetsVisible$ | async) ? 'mb-search-family-line-shrink' : '', 'btn btn-sm mr-1 mb-1 mt-md-2 mt-lg-0 mb-family-line-buttons expand-family-line']"
          (click)="toggleCollapsed()"
  >
    <img src="../../../assets/icons/svg/arrow_up_transparent_background.svg"
         title="Expand"
         alt="Expand icon"
         aria-label="Expand icon"
         data-cy="cms-faq-collapse-button-icon"
    />
  </button>
</ng-template>
